const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class PhxVehicleCatalogServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async listMakes({ name, ids, sort, page = 0, maxPerPage = 10 }) {
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/vehicle-catalog/makes`, {
        params: { name, ids, sort, page, maxPerPage },
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async listModels({ name, makeIds, ids, sort, page = 0, maxPerPage = 10 }) {
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/vehicle-catalog/models`, {
        params: { name, makeIds, ids, sort, page, maxPerPage },
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async listTrims({ name, makeIds, modelIds, ids, sort, page = 0, maxPerPage = 10 }) {
    try {
      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/vehicle-catalog/trims`, {
        params: { name, makeIds, modelIds, ids, sort, page, maxPerPage },
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getProviderInternal(providerId) {
    try {
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/vehicle-catalog/providers/${providerId}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateProviderInternal(providerId, body) {
    try {
      const { data } = await this.httpClient.patch(`/${CURRENT_VERSION}/vehicle-catalog/providers/${providerId}`, body);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async upsertCatalogItemByProviderIdInternal(providerId, id, body) {
    try {
      const { data } = await this.httpClient.put(`/${CURRENT_VERSION}/vehicle-catalog/providers/${providerId}/catalog/${id}`, body);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async markCatalogItemDefunctByProviderIdInternal(providerId, id) {
    try {
      const { data } = await this.httpClient.delete(`/${CURRENT_VERSION}/vehicle-catalog/providers/${providerId}/catalog/${id}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async markCatalogItemDefunctByModelInternal(providerId, id) {
    try {
      const { data } = await this.httpClient.delete(`/${CURRENT_VERSION}/vehicle-catalog/providers/${providerId}/catalog/model/${id}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async markCatalogItemDefunctByGenerationInternal(providerId, id) {
    try {
      const { data } = await this.httpClient.delete(`/${CURRENT_VERSION}/vehicle-catalog/providers/${providerId}/catalog/generation/${id}`);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  PhxVehicleCatalogServiceConnector,
};
